import React from "react";
import "./NewUserRegistration.scss";
import HaqtInput from "../../components/HaqtInput/HaqtInput";
import * as yup from "yup";
import { useFormik } from "formik";
import { createUserRequest } from "../../services/NewUserRegistrationService";
import { useNavigate } from "react-router-dom";
import { notifyError, notifySuccess } from "../../components/Toaster/Toaster";
import userImg from "../../assests/img/userImg.png";
import mailImg from "../../assests/img/mailImg.png";
import lockImg from "../../assests/img/lockImg.png";

const passwordRegex =/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])(.{8,})$/
const emailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const validationSchema = yup.object({
  email: yup
    .string("Enter your Email")
    .matches(emailRegex, "Enter a valid email address")
    .required("Email is required"),
  username: yup
    .string("Enter your User Name")
    .required("User Name is required"),
  password: yup
    .string()
    .min(8, "Password should be of minimum 8 characters length")
    .matches(
      passwordRegex,
      "Password must contain at least one uppercase letter, one lowercase letter,a special character and a number",
    )
    .required("Password is required"),
  confirm: yup
    .string()
    .required("Retype Password is required")
    .oneOf([yup.ref("password"), null], "Password input doesn't match"),
});

const NewUserRegistration = () => {
  const navigate = useNavigate();
  // const [showSuccessBanner, setShowSuccessBanner] = useState(false);
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
      confirm: "",
      username: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      createUserHandler(values);
    },
  });

  const createUserHandler = async (values) => {
    try {
      const valuesCopy = JSON.parse(JSON.stringify(values));
      delete valuesCopy.confirm;
      const response = await createUserRequest(valuesCopy);
      if (response && response.data && response.data.isSuccess) {
        formik.handleReset();
        notifySuccess(
          "An validation email will be sent to your mail box in a short while.",
        );
        navigate("/auth/login");
      }
    } catch (error) {
      notifyError(error);
    }
  };

  return (
    <>
      <div className="user-reg-container">
        <form onSubmit={formik.handleSubmit}>
          <div className="mb-3">
            <HaqtInput
              inputProps={{ maxLength: 40 }}
              id="username"
              name="username"
              className="focus-placeholder"
              placeholder="User Name"
              value={formik.values.username}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.username && Boolean(formik.errors.username)}
              helperText={formik.touched.username && formik.errors.username}
              icon={<img src={userImg} height={17} width={20} />}
            />
          </div>
          <div className="mb-3">
            <HaqtInput
              fullWidth
              id="email"
              name="email"
              className="focus-placeholder"
              placeholder="Email"
              type="text"
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.email && Boolean(formik.errors.email)}
              helperText={formik.touched.email && formik.errors.email}
              icon={<img src={mailImg} height={16} width={20} />}
            />
          </div>
          <div className="mb-3">
            <HaqtInput
              fullWidth
              id="password"
              name="password"
              className="focus-placeholder"
              placeholder="Password"
              type="password"
              value={formik.values.password}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.password && Boolean(formik.errors.password)}
              helperText={formik.touched.password && formik.errors.password}
              icon={<img src={lockImg} height={17} width={20} />}
            />
          </div>
          <div className="mb-4">
            <HaqtInput
              fullWidth
              id="confirm"
              name="confirm"
              className="focus-placeholder"
              placeholder="Retype Password"
              type="password"
              value={formik.values.confirm}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.confirm && Boolean(formik.errors.confirm)}
              helperText={formik.touched.confirm && formik.errors.confirm}
              icon={<img src={lockImg} height={17} width={20} />}
            />
          </div>
          <button type="submit" className="btn btn-primary mb-4  signup-button">
            Register
          </button>
        </form>
      </div>
    </>
  );
};

export default NewUserRegistration;
